module.exports = __webpack_public_path__ + "img/ic_quote_set_default.fde3b243.svg";